import api from "../../utils/apiUser";


export const getPedidos = async ({ limit = 50, cursor = null } = {}) => {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (cursor) params.set("cursor", cursor);

  const res = await api.get(`/api/pedidos?${params.toString()}`);
  return res.data; 
};

export const getPedidoById = async (pedido_id) => {
  const res = await api.get(`/api/pedidos/${pedido_id}`);
  return res.data;
};

export const updateEstadoPedido = async (pedido_id, estado_nuevo) => {
  const res = await api.put(`/api/pedidos/${pedido_id}/estado`, {
    estado_nuevo,
  });
  return res.data;
};

export const confirmarPagoPedido = async (pedido_id) => {
  const res = await api.post(`/api/pedidos/${pedido_id}/pago/confirmar`);
  return res.data;
};

export const getPedidoHistorial = async (pedido_id) => {
  const res = await api.get(`/api/pedidos/${pedido_id}/historial`);
  return res.data;
};
